(function () {
  'use strict';

  angular
    .module('reportwrongspeedviaModule', ['pascalprecht.translate']);
}());
